module.exports = __webpack_public_path__ + "static/img/blog-img2.69ae4e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-img2.jpg
// module id = Q9S7
// module chunks = 1